import React, { FunctionComponent } from 'react';

import { isNumber, round } from 'lodash';
import numeral from 'numeral';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { getPercentValue, getCountValue } from 'core/number/Util';

export enum Mode {
    Count = 'count',
    Percentage = 'percentage',
}

export interface Props {
    value?: number;
    showRaw?: boolean;
    mode?: Mode;
    precision?: number /* precision is only used in percentage */;
    getIsEmptyValue?: (value?: number) => boolean;
}

const getIsEmptyValueFallback = (value?: number): boolean => !value;

export const Number: FunctionComponent<Props> = ({
    value,
    showRaw,
    precision,
    mode,
    getIsEmptyValue = getIsEmptyValueFallback,
}): JSX.Element => {
    const getNumber = (): string => {
        if (getIsEmptyValue(value)) {
            return '-';
        }

        return mode === Mode.Percentage ? `${getPercentValue(value, precision)}%` : `${getCountValue(value)}`;
    };
    const newValue =
        value && isNumber(precision)
            ? numeral(round(value, precision)).format('0,0[.0]')
            : numeral(value).format('0,0');

    return (
        <div className="r4e-number">
            {showRaw ? (
                <OverlayTrigger
                    trigger="hover"
                    placement="top"
                    overlay={<Tooltip id="r4e-number-tooltip">{newValue}</Tooltip>}
                >
                    <span className="number-tooltip">{getNumber()}</span>
                </OverlayTrigger>
            ) : (
                <span className="number-tooltip">{getNumber()}</span>
            )}
        </div>
    );
};

Number.defaultProps = {
    value: 0,
    showRaw: false,
    precision: 0,
    mode: Mode.Count,
};
